// Per-tab last-location memory (NAV-02). Extracted verbatim from ViewTabs.tsx
// so the command palette can reuse rememberedTabLocation for "palette hop
// restores last in-tab location". Imports the shared tree from navTree.ts;
// navTree.ts does NOT import from here (no cycle).
//
// Session-scoped on purpose: a new browser session starts clean at the tab
// roots, but within a session the Alarms → BESS → back loop is lossless. All
// storage access is wrapped — sandboxed iframes can throw on any storage
// touch. The sessionStorage key string ("ems-tabmem:") and the try/catch
// guards are byte-for-byte unchanged; do not alter them or in-session tab
// restore regresses.

import { MODES, isActivePath } from "@/lib/navTree";

const TAB_MEMORY_PREFIX = "ems-tabmem:";

export function rememberTabLocation(pathname: string, search: string): void {
  const owner = MODES.flatMap((m) => m.tabs).find((t) => isActivePath(t, pathname));
  if (!owner) return;
  try {
    sessionStorage.setItem(TAB_MEMORY_PREFIX + owner.path, pathname + search);
  } catch {
    // best-effort — tab links fall back to the tab root
  }
}

export function rememberedTabLocation(tabPath: string): string | null {
  try {
    const v = sessionStorage.getItem(TAB_MEMORY_PREFIX + tabPath);
    return v && v.startsWith("/") ? v : null;
  } catch {
    return null;
  }
}
